import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Academics from "@/pages/Academics";
import Research from "@/pages/Research";
import Admissions from "@/pages/Admissions";
import News from "@/pages/News";
import ColorSwatchDemo from "@/pages/ColorSwatchDemo";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
          <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
          <Route path={ROUTE_PATHS.ACADEMICS} element={<Academics />} />
          <Route path={ROUTE_PATHS.RESEARCH} element={<Research />} />
          <Route path={ROUTE_PATHS.ADMISSIONS} element={<Admissions />} />
          <Route path={ROUTE_PATHS.NEWS} element={<News />} />
          <Route path={ROUTE_PATHS.COLOR_SWATCH} element={<ColorSwatchDemo />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
